import { APIModel } from '@shared/interfaces';
import { PollingStatus, StatusProvider } from '@/tax/models';

export class PersonalTaxParsing implements APIModel {
    id = -1;
    status: PollingStatus = PollingStatus.Init;
    createdAt = new Date();
    statusMessage?: string;
    statusMessageProvider?: StatusProvider;

    deserialize(data: any): this {
        this.id = data.id ?? -1;
        this.status = data.status ?? PollingStatus.Init;
        this.createdAt = data.created_at ? new Date(data.created_at) : this.createdAt;
        this.statusMessage = data.status_message ?? undefined;
        this.statusMessageProvider = data.status_message_provider ?? undefined;
        return this;
    }
}
